import { Button, DatePicker, Divider, Input, Popconfirm, Radio, Select, Space, Tooltip } from "antd";
import moment from "moment";
import React from "react";
import { EyeIcon, EyeSlashIcon } from "../Icons";
import { getComponentLabel, tt_end_date, tt_start_date } from "../../utils/Utils";

export default function EditorPanelHeading(props) {

    const { hide_visibility = false, hide_container = false, hide_date = false, trash = () => { }, close = () => { }, date_changed = 0, setContent = () => { }, content = {}, save = () => { } } = props;

    const {
        name = "",
        visibility = "visible",
        start_date = null,
        end_date = null,
        expiry_action = false,
        container = false,
    } = content;

    const disabledStartRange = (current) => {
        if (end_date) {
            return current && current > moment(end_date * 1000).endOf('day');
        } else {
            return false;
        }
    }

    const disabledEndRange = (current) => {
        if (start_date) {
            return current && current < moment(start_date * 1000).startOf('day');
        } else {
            return current && current < moment().startOf('day');
        }
    }



    return (
        <div>
            <div style={{ "position": "fixed", "zIndex": "2", "width": "255px", "paddingLeft": "3px", "paddingRight": "3px", "backgroundColor": "#f5f5f5", "paddingBottom": "0px", "paddingTop": "25px", "marginTop": "-25px" }}>
                <Tooltip title={<small>{name}</small>}><div style={{ "fontSize": "18px", "whiteSpace": "nowrap", "lineHeight": "18px", maxHeight: "20px", "overflow": "hidden", "textOverflow": "ellipsis" }}><strong>{name}</strong></div></Tooltip>
                <div><small>{getComponentLabel(content.component)}</small></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button onClick={() => save()} block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => close()} size="small" type="default"><small>Cancel</small></Button>
                        <Popconfirm title="Are you sure?" onConfirm={() => trash()}>
                            <Button size="small" danger type="primary"><small>Trash</small></Button>
                        </Popconfirm>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
            </div>
            <div style={{ "height": (name) ? "128px" : "110px" }} />
            {/* CONTENT BLOCK NAME */}
            <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CONTENT BLOCK NAME</Divider>
            <Input maxLength={50} style={{ "fontSize": "11px" }} onChange={(e) => setContent({ ...content, "name": e.target.value })} defaultValue={name} placeholder="Name..." />
            <div className="shim" /><div className="shim" />
            {/* VISIBILITY */}
            {(!hide_visibility && <>

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">VISIBILITY</Divider>
                <Select value={visibility} onChange={(e) => setContent({ ...content, "visibility": e })} style={{ "width": "100%" }}>
                    <Select.Option value="test"><div style={{ "color": "#e77e21", "display": "flex", "alignItems": "center" }}><EyeSlashIcon style={{ "color": "#e77e21" }} /><small>&nbsp; Draft</small></div></Select.Option>
                    <Select.Option value="visible"><div style={{ "color": "#3c8617", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#3c8617" }} /><small>&nbsp; Visible</small></div></Select.Option>
                </Select>
            </>)}

            <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>


            {(!hide_date &&
                <>

                    {/* START & EXPIRY */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={tt_start_date}>START DATE</Tooltip></Divider>
                    <Space>
                        <DatePicker className="bmfix" disabledDate={disabledStartRange} value={(start_date) ? moment(start_date * 1000) : null} format={"MMM Do, YYYY"} placeholder="Select a date..." style={{ "width": "246px", "fontSize": "11px" }} use12Hours onChange={(e) => setContent({ ...content, "start_date": (e) ? e.startOf("day").unix() : null })} />
                    </Space>
                    <div className="shim" /><div className="shim" />
                    {/* EXPIRY DATE & TIME */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={tt_end_date}>EXPIRY DATE</Tooltip></Divider>
                    <DatePicker className="bmfix" disabledDate={disabledEndRange} value={(end_date) ? moment(end_date * 1000) : null} format={"MMM Do, YYYY"} placeholder="Select a date..." style={{ "width": "246px", "fontSize": "11px" }} use12Hours onChange={(e) => setContent({ ...content, "end_date": (e) ? e.endOf("day").unix() : null })} />
                    <div className="shim" /><div className="shim" />
                    {/* EXPIRY ACTION */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">UPON EXPIRY</Divider>
                    <div className="float-flex">
                        <div></div>
                        <Space>
                            <Radio.Group value={expiry_action} onChange={(e) => setContent({ ...content, "expiry_action": e.target.value })} disabled={(!end_date)} >
                                <Radio value={false}><small>Hide</small></Radio>
                                <Radio value={true}><small>Trash</small></Radio>
                            </Radio.Group>
                        </Space>
                    </div>
                    <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                </>
            )}

            {(!hide_container &&
                <>
                    {/* CONTAINER */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CONTAINER</Divider>
                    <div className="float-flex">
                        <div></div>
                        <Space>
                            <Radio.Group value={container} onChange={(e) => setContent({ ...content, "container": e.target.value })} >
                                <Radio value={false}><small>100% of the screen width</small></Radio>
                                <Radio value={true}><small>Container width (max 1248px)</small></Radio>
                            </Radio.Group>
                        </Space>
                    </div>
                    <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                </>
            )}
        </div>
    )
}